<script lang="ts">
    import { Col, Image } from "sveltestrap";
    import Card from "../UiCommenCard.svelte";
    import data from "../../../Data/ComponentData/Ui-kits/Avatars/Avatars.json";
    let imgPath : string= '/assets/images/user';
    import { SatusIndicators } from "../../../utils/Constant/Constant";
</script>

<Col sm="12">
    <Card cardHeaderprops="pb-0" headerTitle={SatusIndicators} CardBodyprops="avatar-showcase">
        <div slot="contentbody">
            <div class="avatars">
                <div class="avatar">
                    <Image
                        class="img-100 rounded-circle"
                        src="{imgPath}/1.jpg"
                        alt="#"
                    />
                    <div class="status status-100 bg-primary" />
                </div>
                {#each data.Status as imgItem}
                    <div class="avatar">
                        <Image
                            class="{imgItem.class1} rounded-circle"
                            src="{imgPath}/1.jpg"
                            alt="#"
                        />
                        <div class="status {imgItem.class2} bg-primary" />
                    </div>
                {/each}
            </div>
        </div>
    </Card>
</Col>
